import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const PaymentNav = ({ routes }) => {
  const [active, setActive] = useState(0);
  const location = useLocation();

  useEffect(() => {
    console.log(location.pathname);
    if (location.pathname === "/Admin/Notification") {
      setActive(0);
    } else if (location.pathname === "/Admin/University") {
      setActive(1);
    } else if (location.pathname === "/Admin/Career") {
      setActive(2);
    } else if (location.pathname === "/Admin/Procedure") {
      setActive(3);
    } else if (location.pathname === "/Admin/Staff") {
      setActive(4);
    } else if (location.pathname === "/Admin/Position") {
      setActive(5);
    } else if (location.pathname === "/Admin/Student") {
      setActive(6);
    } else if (location.pathname === "/Admin/FourMonth") {
      setActive(7);
    } else if (location.pathname === "/Admin/Config") {
      setActive(8);
    } else if (location.pathname === "/Admin/Franchises") {
      setActive(9);
    }
  }, [location.pathname]);

  return (
    <nav style={{
      backgroundColor: '#1f2937',
      borderBottom: '1px solid #374151',
      padding: '0 16px',
      display: 'flex',
      alignItems: 'center',
      overflowX: 'auto',
      marginBottom: '24px',
    }}>
      <div style={{ display: 'flex', gap: '2px', padding: '6px 0' }}>
        {routes.map((item) => (
          <Link
            key={item.key}
            to={item.key}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              padding: '6px 16px',
              borderRadius: '5px',
              fontSize: '0.75rem',
              fontWeight: 600,
              textDecoration: 'none',
              whiteSpace: 'nowrap',
              transition: 'all 0.15s',
              backgroundColor: active === item.active ? '#dc2626' : 'transparent',
              color: active === item.active ? '#fff' : '#9ca3af',
            }}
            onMouseEnter={e => { if (active !== item.active) { e.currentTarget.style.backgroundColor = '#374151'; e.currentTarget.style.color = '#f9fafb'; } }}
            onMouseLeave={e => { if (active !== item.active) { e.currentTarget.style.backgroundColor = 'transparent'; e.currentTarget.style.color = '#9ca3af'; } }}
          >
            {item.name}
          </Link>
        ))}
      </div>
    </nav>
  );
};

export default PaymentNav;
